/** @format */

import React, { useState, useEffect, useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { payOptionService } from '../../Services/payoption.service';
import CardWrap from '../Common/CardWrap';
import ResultModal from '../Common/ResultModal';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../Contexts/AuthContext';
import { roles } from '../../Config/Roles';
import Tooltip from '../Common/Tooltip';
import { GlobalContext } from '../../Contexts/GlobalContextProvider';
import { lettersOnly } from '../../Config/Regex';

export default function AddPayOption() {
	const { t: translator } = useTranslation();
	const { register, handleSubmit, errors } = useForm({
		mode: 'onChange',
		reValidateMode: 'onChange',
	});
	const history = useHistory();
	const { roleId } = useContext(AuthContext);
	const { locName, locTenant, locStore } = useContext(GlobalContext);
	const { master, admin } = roles;

	useEffect(() => {
		if (![master, admin].includes(Number(roleId)))
			history.push('/error-page/401');
	}, []);

	const initialState = {
		name: '',
		tag: '',
		useFiscalization: true,
	};

	const [payOption, setPayOption] = useState(initialState);
	const [modal, setModal] = useState({
		title: '',
		text: '',
		show: false,
		btnClass: '',
		success: true,
	});

	const goBack = () => {
		let backedId = 0;
		switch (locName) {
			case 'tenants':
				backedId = locTenant != 0 ? locTenant : '';
				break;
			case 'stores':
				backedId = locStore != 0 ? locStore : '';
				break;
			default:
				history.push('/pay-methods');
		}
		history.push(`/${locName}/${backedId !== 0 ? backedId : ''}`);
	};

	const handleClose = () => {
		setModal({ show: false });
		if (modal.success === true) {
			goBack();
		}
	};

	const checkboxChange = input => e => {
		setPayOption({ ...payOption, [input]: !payOption[input] });
	};

	const onSubmit = data => {
		payOptionService
			.create({
				name: data.name,
				tag: data.tag,
				fiscalTag: data.fiscalTag,
				useFiscalization: payOption.useFiscalization,
			})
			.then(res => {
				res.data.success
					? setModal({
							show: true,
							title: translator('PayOption-AddPayOption-SuccesModal-Title'),
							text: translator('PayOption-AddPayOption-SuccesModal-Text'),
							btnClass: 'btn btn-primary',
							success: true,
					  })
					: setModal({
							show: true,
							title: translator('PayOption-AddPayOption-UnsuccesModal-Title'),
							text: translator('PayOption-AddPayOption-UnsuccesModal-Text'),
							btnClass: 'btn btn-primary',
							success: false,
					  });
			})
			.catch(err =>
				setModal({
					show: true,
					title: translator('PayOption-AddPayOption-UnsuccesModal-Title'),
					text: translator('PayOption-AddPayOption-UnsuccesModal-Text'),
					btnClass: 'btn btn-primary',
					success: false,
				}),
			);
	};

	const handleCancel = () => {
		history.push('/pay-methods');
	};

	return (
		<CardWrap
			subtitle={translator('PayOption-AddPayOption-Subtitle')}
			backUrl={'/pay-methods'}>
			<form onSubmit={handleSubmit(onSubmit)} className='row'>
				<div className='col-lg-4'>
					<fieldset className='scheduler-border'>
						<legend className='scheduler-border'>
							{translator('PayOption-AddPayOption-MainData')}
						</legend>
						<div className='form-group'>
							<label>{translator('PayOption-AddPayOption-Name')}</label>{' '}
							<Tooltip text={translator('PayOption-Name-Msg')} />
							<input
								type='text'
								className='form-control'
								ref={register({
									required: true,
									pattern: lettersOnly,
									maxLength: 20,
								})}
								name='name'
								defaultValue={payOption.name}
							/>
							{errors.name && errors.name.type === 'required' && (
								<p className='text-danger'>
									{translator('ValidationMsg-RequiredField')}
								</p>
							)}
							{errors.name && errors.name.type === 'pattern' && (
								<p className='text-danger'>
									{translator('ValidationMsg-LettersOnly')}
								</p>
							)}
							{errors.name && errors.name.type === 'maxLength' && (
								<p className='text-danger'>
									{translator('ValidationMsg-MaxLength20')}
								</p>
							)}
						</div>

						<div className='form-group'>
							<label>{translator('PayOption-AddPayOption-Tag')}</label>{' '}
							<Tooltip text={translator('PayOption-Tag-Msg')} />
							<input
								className='form-control'
								ref={register({
									required: true,
									maxLength: 1,
								})}
								name='tag'
							/>
							{errors.tag && errors.tag.type === 'required' && (
								<p className='text-danger'>
									{translator('ValidationMsg-RequiredField')}
								</p>
							)}
							{errors.tag && errors.tag.type === 'maxLength' && (
								<p className='text-danger'>
									{translator('ValidationMsg-MaxLength1')}
								</p>
							)}
						</div>
						<div className='form-group'>
							<label htmlFor='ddlStore'>
								{translator('PaymentMethod-FiscalTag')}
							</label>
							<select
								className='form-control'
								name='fiscalTag'
								aria-label='Default select example'
								ref={register({ required: true })}
								onChange={e => {
									// setFiscalTagValue(e.target.value);
									// setSelectedCards([]);
								}}>
								<option>G</option>
								<option>K</option>
								<option>T</option>
								<option>O</option>
							</select>

							{errors.fiscalTag && errors.fiscalTag.type === 'required' && (
								<p className='text-danger'>
									{translator('ValidationMsg-RequiredField')}
								</p>
							)}
						</div>
						<div className='form-group'>
							<label className='labelCont'>
								<input
									type='checkbox'
									name='useFiscalization'
									checked={payOption.useFiscalization}
									onChange={checkboxChange('useFiscalization')}
								/>
								<span className='checkmark'></span>
							</label>
							<span>
								{translator('PayOption-AddPayOption-UseFiscalization')}
							</span>{' '}
							<Tooltip text={translator('PayOption-UseFiscalization-Msg')} />
						</div>
					</fieldset>
				</div>
				<div
					className='container-fluid'
					style={{ display: 'flex', justifyContent: 'flex-end' }}>
					<button className='btn btn-outline-secondary' onClick={handleCancel}>
						{translator('Btn-Cancel')}
					</button>
					&nbsp;
					<button className='btn btn-primary' type='submit'>
						{translator('Btn-Save')}
					</button>
				</div>
			</form>
			<ResultModal
				show={modal.show}
				title={modal.title}
				text={modal.text}
				btnClass={modal.btnClass}
				handleClose={handleClose}
			/>
		</CardWrap>
	);
}
